module.exports = __webpack_public_path__ + "static/media/watermark1.2d8b4555.png";